import React from 'react';
import createReactClass from 'create-react-class';
import config from './config/shipmentsConfig';
import request from '../../helpers/request';
import setViewTitle from '../../helpers/setViewTitle';
import SimplePage from '../common/SimplePage';
import { Form, AdornedInput, Input } from '../common/Forms';
import AjaxInProgressHOC from '../common/AjaxInProgressHOC';

var PreparedShipment = createReactClass({

  componentWillMount() {
    setViewTitle('Wareneingangsdokument');
  },

  getInitialState() {
    return {
      lines: []
    };
  },

  componentDidMount() {
    request.get({
      url: config.apiUrl + 'prepared/' + this.props.match.params.purchaseOrderId,
      success: shipment => {
        if (this.isMounted()) {
          shipment.lines.forEach(x => x.stockUnitQuantity = Math.max(0, x.orderedStockUnitQuantity - x.deliveredStockUnitQuantity));

          this.setState(
            shipment
          );
        }
      }
    });
  },

  handleSubmit() {
    var shipment = this.form.getModel();
    this.submit(shipment, false);
  },

  handleSubmitAndClosePurchaseOrder() {
    var shipment = this.form.getModel();
    this.submit(shipment, true);
  },

  submit(shipment, closeOrder) {
    shipment.id = this.state.id;
    shipment.orderId = this.state.orderId;
    shipment.closeOrder = closeOrder;
    shipment.shipmentId = this.state.shipmentId;

    request.post({
      url: config.apiUrl + 'new',
      data: shipment,
      success: () => {
        this.props.history.push('/purchaseorders/ordered/overview');
      }
    });
  },
  render() {
    var displayLines = this.state.lines.map((line, index) => (
        <tr key={index}>
            <Input name={`lines[${index}].itemId`} type="hidden" required value={line.itemId} />
            <Input name={`lines[${index}].stockUnitQuantity`} type="hidden" required value={line.deliveredStockUnitQuantity} />
            <Input name={`lines[${index}].storageLocationId`} type="hidden" required value={line.storageLocationId} />
            <td className="col-md-2">{line.itemName}</td>
            <td className="col-md-1">{line.stockUnitName}</td>
            <td className="col-md-1">{line.orderedStockUnitQuantity}</td>
            <td className="col-md-1">{line.deliveredStockUnitQuantity}</td>
            <td className="col-md-1">
              <AdornedInput
                layout="elementOnly"
                name={`lines[${index}].lineNetPrice`}
                id={`lines[${index}].lineNetPrice`}
                type="number"
                addonBefore="€"
                value={line.lineNetPrice}
                validations="isMoreThan:0"
                required
              />
            </td>
            <td>{line.storageLocationName}</td>
        </tr>
      ));

    const disableSubmit = !this.state.isValid || this.props.isAjaxInProgress;

    const footer = (
      <footer>
        {/*{<button type="button" className="btn btn-primary" onClick={this.handleSubmit} disabled={disableSubmit}>Speichern</button>}*/}
        <button type="button" className="btn btn-success" onClick={this.handleSubmitAndClosePurchaseOrder} disabled={disableSubmit}>Speichern und abschließen</button>
      </footer>
    );

    return (
      <SimplePage title="Wareneingangsdokument">
        <Form ref={c => this.form = c}
          onValid={() => this.setState({isValid: true})}
          onInvalid={() => this.setState({isValid: false})}
          footer={footer}>
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Artikel</th>
                  <th>Basiseinheit</th>
                  <th>Bestellmenge</th>
                  <th>Liefermenge</th>
                  <th>Preis</th>
                  <th>Lagerort</th>
                </tr>
              </thead>
              <tbody>
                  {displayLines}
              </tbody>
            </table>
          </div>
        </Form>
      </SimplePage>
    );
  }
});

export default AjaxInProgressHOC(PreparedShipment);



// WEBPACK FOOTER //
// ./src/components/shipments/PreparedShipment.js